import React, { useState } from 'react';
import { Button } from 'shared-components';
import LoginService from '../../Services/LoginService';
import { LoginCard } from './LoginCard';
import { LoginShell } from './LoginShell';

type Props = {
	hash: string;
};

export default function FirstTimePassword({ hash }: Props) {
	const [sending, setSending] = useState(false);
	const [sent, setSent] = useState(false);
	const [error, setError] = useState<string | null>(null);

	const requestLink = async () => {
		setSending(true);
		setError(null);
		try {
			const response = await LoginService.requestPasswordByHash(hash);
			if ('error' in response && response.error) {
				setError('Too many attempts. Please wait a moment before trying again.');
				return;
			}
			setSent(true);
		} catch (err) {
			console.error(err);
			setError('Unable to send a password setup link right now.');
		} finally {
			setSending(false);
		}
	};

	return (
		<LoginShell>
			<LoginCard>
				<h1 className="login-title">Set up your password</h1>
				<p className="login-description">
					We&apos;ll email you a secure link to set a password for this account.
				</p>
				{error ? (
					<p className="login-error" role="alert">
						{error}
					</p>
				) : null}
				{sent ? (
					<p className="login-success" role="status">
						We&apos;ve sent a secure link to set your password.
					</p>
				) : (
					<Button
						className="login-button"
						color="primary"
						size="md"
						variant="contained"
						onClick={requestLink}
						disabled={sending}
					>
						{sending ? 'Sending...' : 'Email me the link'}
					</Button>
				)}
			</LoginCard>
		</LoginShell>
	);
}
